﻿function setCaption(imageId) {
    const galleryId = $('[data-image-gallery-id]').data('image-gallery-id');
    $.get("/get-image-caption/" + imageId + "/" + galleryId, function (response) {
        $('[data-slider-caption-container]').html(response);
        $('[data-slider-caption-container]').show();
    });
}

function updateUrl(event) {
    const history = window.History;
    const stateData = {};
    const imageId = event.target.currSlide.imageId || event.target.currSlide.caption?.prevObject.data('image-id');
    if (!imageId) {
        return;
    }
    setCaption(imageId);
    stateData.image = imageId;
    const queryString = $.param(stateData);
    stateData.doNotReloadAds = true;
    history.replaceState(stateData, $('title').html(), location.pathname + '?' + queryString);
}

function setupAdHolder(holder, type) {
    const ad = $('<div data-ad-holder>');
    const adHolderId = 'ad-' + type + '-' + (new Date()).getTime();
    ad.attr('id', adHolderId);
    holder.append(ad);
    return adHolderId;
}

function checkHolder(element, selector) {
    const holder = element.find(selector);
    const slot = holder.data('ad-slot');
    return holder;
}

function loadLeaderboard(slider) {
    const holder = checkHolder(slider, '.rsLeaderboardHolder');
    if (holder == null)
        return;
    const adHolderId = setupAdHolder(holder, 'leaderboard');
}

function loadMpus(slider) {
    if (window.isViewportLessThan('md')) {
        return;
    }
    let holder = checkHolder(slider, '.rsMpuHolder > .mpu-1-holder');
    let adHolderId;
    if (holder != null) {
        adHolderId = setupAdHolder(holder, 'mpu-1');
    }
    holder = checkHolder(slider, '.rsMpuHolder > .mpu-2-holder');
    if (holder != null) {
        adHolderId = setupAdHolder(holder, 'mpu-2');
    }
}

function toggleNavigation(slider, hide, timeout = 5000) {
    const rsOverflow = slider.querySelector('.rsOverflow');
    if (rsOverflow) {
        if (hide) {
            rsOverflow.classList.add('rsNoDrag');
        } else {
            rsOverflow.classList.remove('rsNoDrag');
        }
    }
    Array.from(slider.querySelectorAll('.rsArrow')).forEach(function (arrow) {
        arrow.style.display = hide ? 'none' : 'block';
    });
    if (hide) {
        setTimeout(function () {
            console.log('[Gallery] Navigation toggle timeout');
            toggleNavigation(slider, false, timeout);
        }, timeout);
    }
}

function loadSlideMpu(slider, slide) {
    $('[data-slider-caption-container]').hide();
    const existingSlot = slide.data('ad-slot');
    toggleNavigation(slider.slider[0], true, slider.st.adNavLockout || 5000);
}

function unlockNav(event) {
    const slot = event.slot;
    if (!slot.lockedNav) return;
    const slider = slot.slider;
    toggleNavigation(slider.slider[0], false, slider.st.adNavLockout || 1500);
}

function tryLoadMpu(event) {
    const slide = event.target.currSlide.content;
    if (slide.data('gallery-ad')) {
        loadSlideMpu(event.target, slide);
        ayManagerEnv.changePage();
    }
}

function reloadFixedAds(event) {
    const $slider = event.target;
    $slider.leaderboardReloadCount += 1;
    if ($slider.leaderboardReloadCount >= $slider.st.leaderboardReloadAfter) {
        loadLeaderboard($slider.slider);
        ayManagerEnv.refresh(['leaderboard-1-gallery', 'mpu-1-gallery', 'mpu-2-gallery'], { mode: 'visible' });
        $slider.leaderboardReloadCount = 0;
    }
    if (!window.isViewportLessThan('md')) {
        $slider.mpuReloadCount += 1;
        if ($slider.mpuReloadCount >= $slider.st.mpuReloadAfter) {
            loadMpus($slider.slider);
            ayManagerEnv.refresh(['leaderboard-1-gallery', 'mpu-1-gallery', 'mpu-2-gallery'], { mode: 'visible' });
            $slider.mpuReloadCount = 0;
        }
    }
}

function postSlideChange(event) {
    const $slider = event.target;
    if (!$slider.slider.hasClass('rsFullscreen'))
        return;
    if ($slider.changeEventsDisabled) {
        return;
    }
    if ($slider.changeEventsDisabledByGoto) {
        $slider.changeEventsDisabledByGoto = false;
        return;
    }
    reloadFixedAds(event);
    tryLoadMpu(event);
    updateUrl(event);
}

function setup() {
    window.loadGallery = function () {
        const sliders = $("[data-slider-gallery]");
        if (sliders.length === 0)
            return;
        sliders.each(function (index, element) {
            const $element = $(element);
            if ($element.data('royalSlider') != null)
                return;
            const slides = $element.children().clone();
            const desktopSlides = slides.filter('a').clone();
            const options = {
                arrowsNavAutoHide: false,
                imageScaleMode: 'fit-if-smaller',
                imageScalePadding: 0,
                controlNavigationSpacing: 0,
                controlNavigation: "none",
                loop: true,
                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: true,
                slidesSpacing: 0,
                minSlideOffset: 0,
                leaderboardReloadAfter: $element.data('leaderboard-reload-after') || 4,
                mpuReloadAfter: $element.data('mpu-reload-after') || 4,
                adNavLockout: $element.data('ad-nav-lockout') || 1500,
                fullscreen: {
                    enabled: true,
                    nativeFS: false
                }
            };
            $element.royalSlider(options);
            const slider = $element.data('royalSlider');
            const mpuHolder = $('<div class="rsMpuHolder">');
            const mpu1 = $('<div class="mpu-1-holder mb-3">').appendTo(mpuHolder);
            const mpu2 = $('<div class="mpu-2-holder mb-3">').appendTo(mpuHolder);
            $element.prepend(mpuHolder);
            const leaderboardHolder = $('<div class="rsLeaderboardHolder">').prependTo($element);
            slider.ev.on('rsExitFullscreen', function () {
                $('#heading-group').css('z-index', '2');
                $element.hide();
                $element.removeClass("fullscreen");
            });
            slider.ev.on('rsBeforeSizeSet', function () {
                const leaderboardHolderHeight = leaderboardHolder.outerHeight(true);
                const mpuHolderWidth = mpuHolder.outerWidth(true);
                slider._wrapHeight = slider._wrapHeight - leaderboardHolderHeight;
                slider._wrapWidth = slider._wrapWidth - mpuHolderWidth;
            });
            $element.hide();
            slider.allSlides = jQuery.extend(true, [], slider.slides);
            slider.desktopSlides = $(slider.allSlides).filter(function (index, element) {
                return element.images !== null
            }).get();
            function goToFast(indexOf) {
                slider.changeEventsDisabledByGoto = true;
                const temp = slider.st.transitionSpeed;
                slider.st.transitionSpeed = 0;
                slider.goTo(indexOf, true);
                slider.st.transitionSpeed = temp;
            }
            function setToDesktop(init) {
                slider.changeEventsDisabled = true;
                if (slider.currSlide.images == null) {
                    slider.goTo(slider.currSlideId - 1, true);
                }
                const indexOf = slider.desktopSlides.findIndex(function (element) {
                    return element.images[0] === slider.currSlide.images[0];
                });
                while (slider.slides.length > 0) {
                    slider.removeSlide(0);
                }
                for (let i = 0; i < slider.desktopSlides.length; i++) {
                    const slide = desktopSlides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function () {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            function setToMobile() {
                slider.changeEventsDisabled = true;
                const indexOf = slider.allSlides.findIndex(function (element) {
                    return element.images != null && element.images[0] === slider.currSlide.images[0];
                });
                while (slider.slides.length > 0) {
                    slider.removeSlide(0);
                }
                for (let i = 0; i < slider.allSlides.length; i++) {
                    const slide = slides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function () {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            $(document).on('viewport-changed', function (event, data) {
                if (data.from !== document.viewportSize.mobile && data.to !== document.viewportSize.mobile) {
                    return;
                }
                if (data.to === document.viewportSize.mobile) {
                    setToMobile();
                } else if (data.from === document.viewportSize.mobile) {
                    setToDesktop();
                }
                loadLeaderboard($element);
                loadMpus($element);
                slider.leaderboardReloadCount = 0;
            });
            slider.ev.on('rsEnterFullscreen', function () {
                ayManagerEnv.changePage();
                $('#heading-group').css('z-index', '1');
                $element.show();
                $element.addClass("fullscreen");
                const defaultImageId = $('[data-default-image-id]').data('default-image-id');
                setCaption(defaultImageId);
                loadLeaderboard($element);
                loadMpus($element);
                if (!window.isViewportLessThan('md')) {
                    setToDesktop();
                } else {
                    setToMobile();
                }
            });
            slider.leaderboardReloadCount = 0;
            slider.mpuReloadCount = 0;
            slider.ev.on('rsAfterSlideChange', postSlideChange);
            window.gallerySliderData = slider;
            const siblings = $element.siblings('[data-slider-caption-container]');
            const caption = $element.find('.rsGCaption');
            caption.appendTo(siblings);
        });
    };
}

function launchGallery(event) {
    event.preventDefault();
    const $this = $(event.currentTarget);
    const galleryName = $this.closest('.article-gallery').find('[data-slider-gallery]').data('slider-gallery');
    const gallery = $('[data-slider-gallery="' + galleryName + '"]');
    const slider = gallery.data('royalSlider');
    if (!slider)
        return;
    const index = $this.data('gallery-launcher-index');
    if (typeof index == "undefined")
        return;
    const slide = $(slider.allSlides).filter(function (_, element) {
        return element.id === index;
    }).get(0);
    if (slide == null)
        return;
    const slideIndex = slider.slides.findIndex(function (element) {
        return element.images != null && element.images[0] === slide.images[0];
    });
    if (slideIndex === -1)
        return;
    slider.goTo(slideIndex, false);
    setTimeout(function () {
        slider.enterFullscreen();
    }, 51);
}

export function setupGallery() {
    setup();
    window.loadGallery();
    $(document).on('click', '[data-gallery-launcher]', launchGallery);
}